webpackJsonp([0],{

/***/ "+D/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("Nklb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff4a535c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("UVIj");
function injectStyle (ssrContext) {
  __webpack_require__("n3qc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff4a535c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Mmg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "/uTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");



var _mutations;




// initial state
var state = {
  adminBusy: false,
  adminOffset: 0,
  adminInfo: {},
  adminList: []
};

// getters
var getters = {
  adminBusy: function adminBusy(stateFreezed) {
    return stateFreezed.adminBusy;
  },
  adminList: function adminList(stateFreezed) {
    return stateFreezed.adminList;
  },
  adminInfo: function adminInfo(stateFreezed) {
    return stateFreezed.adminInfo;
  }
};

// actions
var actions = {
  fetchAdminList: function fetchAdminList(_ref, tag) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADMIN_LIST_BUSY */], true);
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('refs/?offset=' + state.adminOffset + '&tag=' + tag).then(function (response) {
      if (response.body.results) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* RECEIVE_ADMIN_LIST */], response.body);
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ADMIN_LIST_OFFSET */]);
        if (response.body.next) commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADMIN_LIST_BUSY */], false);
      }
    });
  },
  voteAdminImg: function voteAdminImg(_ref2, params) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('refs/' + params.ref.id + '/estimate/', { value: params.value }, { emulateJSON: true });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* UPDATE_ADMIN_LIST_VOTE */], { key: params.key, value: params.value });
  },
  TagAdminImg: function TagAdminImg(_ref3, params) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.put('refs/' + params.id + '/', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ tags: [params.tags] }), { emulateJSON: true });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* UPDATE_ADMIN_LIST */], params.number);
  },
  deleteAdminImg: function deleteAdminImg(_ref4, params) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.delete('refs/' + params.id + '/');
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* UPDATE_ADMIN_LIST */], params.number);
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* RECEIVE_ADMIN_LIST */], function (stateFreezed, adminFetched) {
  var st = stateFreezed;
  st.adminInfo = adminFetched;
  st.adminList = st.adminList.concat(adminFetched.results);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* UPDATE_ADMIN_LIST */], function (stateFreezed, key) {
  var st = stateFreezed;
  st.adminList.splice(key, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* UPDATE_ADMIN_LIST_VOTE */], function (stateFreezed, params) {
  var st = stateFreezed;
  st.adminList[params.key].has_estimated = params.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ADMIN_LIST_OFFSET */], function (stateFreezed) {
  var st = stateFreezed;
  st.adminOffset += 20;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADMIN_LIST_BUSY */], function (stateFreezed, status) {
  var st = stateFreezed;
  st.adminBusy = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* CLEAR_ADMIN_LIST */], function (stateFreezed) {
  var st = stateFreezed;
  st.adminBusy = false;
  st.adminOffset = 0;
  st.adminList = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["z" /* TAG_ADMIN_UPDATE */], function (stateFreezed, params) {
  var st = stateFreezed;
  var updatedList = st.adminList;
  var updatedRef = st.adminList[params.key];
  updatedRef.tags = [params.tag];
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(updatedList, params.key, updatedRef);
  st.adminList = updatedList;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "17x+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_browser__ = __webpack_require__("Z4iZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");





// initial state
var state = {
  globals: {},
  likes: [],
  browser: Object(__WEBPACK_IMPORTED_MODULE_2__utils_browser__["a" /* default */])(),
  tags: [{
    name: 'Веб',
    name_plural: 'Вебa',
    name_in: 'вебе',
    tag: 'web',
    value: 2
  }, {
    name: 'Граф',
    name_plural: 'Графa',
    name_in: 'графе',
    tag: 'graphical',
    value: 4
  }, {
    name: 'Пром',
    name_plural: 'Промa',
    name_in: 'проме',
    tag: 'industrial',
    value: 1 // for uploading form
  }, {
    name: 'Шрифт',
    name_plural: 'Шрифтa',
    name_in: 'шрифте',
    tag: 'font',
    value: 3
  }]
};

// getters
var getters = {
  globals: function globals(stateFreezed) {
    return stateFreezed.globals;
  },
  browser: function browser(stateFreezed) {
    return stateFreezed.browser;
  },
  likes: function likes(stateFreezed) {
    return stateFreezed.likes;
  },
  tags: function tags(stateFreezed) {
    return stateFreezed.tags;
  }
};

// actions
var actions = {
  fetchGlobal: function fetchGlobal(_ref) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('global/').then(function (response) {
      // get body data
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* RECEIVE_GLOBAL */], response.body.content);
    });
  }
};

// mutations
var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["u" /* RECEIVE_GLOBAL */], function (stateFreezed, globFetched) {
  var st = stateFreezed;
  st.globals = globFetched;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "1NEM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Footer__ = __webpack_require__("3loQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Stat__ = __webpack_require__("rAxH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Greeting',
  components: {
    Footy: __WEBPACK_IMPORTED_MODULE_1__layouts_Footer__["a" /* default */],
    Stat: __WEBPACK_IMPORTED_MODULE_2__layouts_Stat__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personCurrent: 'personCurrent',
    personIsAuth: 'personIsAuth',
    person: 'person'
  }),
  mounted: function mounted() {
    var firstVisit = this.$cookie.get('first-visit');
    if (!this.$route.params.tag) {
      if (!firstVisit) {
        this.showPersonPage();
      } else {
        this.$store.commit('SET_CATEGORY', 'all');
      }
    }
  },


  methods: {
    showPersonPage: function showPersonPage() {
      var _this = this;

      var waitUser = setInterval(function () {
        if (_this.personCurrent.id) {
          clearInterval(waitUser);
          _this.$cookie.set('first-visit', 'true', 999999);
          _this.$router.push('/accounts/' + _this.personCurrent.id + '/');
        }
      }, 100);
    }
  }
});

/***/ }),

/***/ "1XP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("app-" + _vm.browser),attrs:{"id":"app"}},[_c('Heady'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1wd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Graph__ = __webpack_require__("5qpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objects__ = __webpack_require__("BB+s");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccStat',
  components: {
    Graph: __WEBPACK_IMPORTED_MODULE_1__components_Graph__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    compare: 'compare',
    tags: 'tags'
  }),
  methods: {
    getCategoryBySlug: function getCategoryBySlug(like) {
      var tag = Object(__WEBPACK_IMPORTED_MODULE_2__utils_objects__["a" /* default */])(this.tags, like.slug, 'slug');
      return tag.name;
    }
  },
  data: function data() {
    return {
      drawGraph: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.drawGraph = true;
    }, 600);
  }
});

/***/ }),

/***/ "2EcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("user--list user--list-" + (_vm.listSorted && _vm.listSorted.length > 0 ? 'active' : '') + " user--list-" + (_vm.direction ? 'right' : 'left'))},[(!_vm.direction && _vm.detectLeftNeighbour())?_c('div',{staticClass:"user--list-person user--list-person-percent",style:(("opacity: 0.2; transform: translate3d(" + (_vm.calcPosition(0) * 1.65) + "px, 0, 0) scale(0.77); z-index: 0;")),on:{"click":function($event){_vm.updateUser(_vm.detectLeftNeighbour().id)}}},[_c('router-link',{attrs:{"to":((_vm.calcLink(_vm.category)) + "/accounts/" + (_vm.detectLeftNeighbour().id) + "/")}},[_c('div',{staticClass:"user--avatar-preview"},[_vm._v(_vm._s(_vm.detectLeftNeighbourCompare() || 0)+"%")])])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.listSorted),function(men, key){return _c('div',{key:men.id,class:['user--list-person', {'user--list-tema': _vm.tema === men.id}],style:(("opacity: " + (_vm.calcOpacity(key)) + ";transform: translate3d(" + (_vm.calcPosition(key)) + "px, 0, 0) scale(" + (_vm.calcScale(key)) + "); z-index: " + (_vm.calcZindex(key)) + ";")),on:{"click":function($event){_vm.updateUser(men.id)}}},[_c('router-link',{attrs:{"to":((_vm.calcLink(_vm.category)) + "/accounts/" + (men.id) + "/")}},[(men.profile_photo)?_c('img',{attrs:{"src":men.profile_photo}}):(men.first_name)?_c('div',{staticClass:"user--avatar-preview",style:(("background: " + (_vm.calcColor(men.compare_etalon))))},[_vm._v(_vm._s(men.first_name[0])+_vm._s(men.last_name[0]))]):_vm._e()])],1)}),_vm._v(" "),(_vm.direction && _vm.listSorted.length > _vm.limit && _vm.detectRightNeighbour())?_c('div',{staticClass:"user--list-person user--list-person-100",style:(("opacity: 0.2; transform: translate3d(" + (_vm.calcPosition(_vm.listSorted.length - 1) * 1.5) + "px, 0, 0) scale(0.77); z-index: 1;")),on:{"click":function($event){_vm.updateUser(_vm.detectRightNeighbour().id)}}},[_c('router-link',{attrs:{"to":((_vm.calcLink(_vm.category)) + "/accounts/" + (_vm.detectRightNeighbour().id) + "/")}},[_c('div',{staticClass:"user--avatar-preview"},[_vm._v(_vm._s(_vm.detectRightNeighbour().compare_etalon)+"%")])])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2HRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.person.id && _vm.isGraph())?_c('div',{staticClass:"switcher"},[_c('div',{staticClass:"switcher-link",on:{"click":function($event){_vm.updateCategory(_vm.all)}}},[(_vm.category === _vm.all)?_c('span',{staticClass:"switcher-link-icon"},[_c('img',{attrs:{"src":"/static/rating.svg"}})]):_vm._e(),_vm._v(" "),_c('router-link',{class:['switcher-link-a', {'switcher-link-a-active': _vm.all === _vm.category}],attrs:{"to":_vm.link(_vm.all)}},[_vm._v("Все")])],1),_vm._v(" "),_vm._l((_vm.tags),function(cat){return _c('div',{staticClass:"switcher-link",on:{"click":function($event){_vm.updateCategory(cat.tag)}}},[(cat.tag === _vm.category)?_c('span',{staticClass:"switcher-link-icon"},[_c('img',{attrs:{"src":"/static/rating.svg"}})]):_vm._e(),_vm._v(" "),_c('router-link',{class:['switcher-link-a', {'switcher-link-a-active': cat.tag === _vm.category}],attrs:{"to":_vm.link(cat.tag)}},[_vm._v(_vm._s(cat.name))])],1)})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2RGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Navigation__ = __webpack_require__("bwGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Switcher__ = __webpack_require__("xBuU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_colorLibrary__ = __webpack_require__("QIYI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'heady',
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_2__components_Navigation__["a" /* default */],
    Switcher: __WEBPACK_IMPORTED_MODULE_3__components_Switcher__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personIsAdmin: 'personIsAdmin',
    person: 'personCurrent',
    fancyCounter: 'fancyCounter',
    fancyList: 'fancyList',
    fancyInfo: 'fancyInfo',
    theme: 'theme'
  }),

  methods: {
    updateUser: function updateUser(userId) {
      var _this = this;

      this.$store.commit('SET_CATEGORY', 'all');
      if (this.person.id > 0) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["h" /* CLEAR_PERSONS */]);
        setTimeout(function () {
          _this.$store.dispatch('fetchPerson', userId);
        }, 200);
      }
    },
    calcColor: function calcColor(coeff) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_colorLibrary__["a" /* default */])(coeff).top;
    },
    profileLink: function profileLink() {
      return this.personIsAdmin ? '/refs/web/' : '/accounts/' + this.person.id + '/';
    }
  }
});

/***/ }),

/***/ "2U12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'errorPage',
  metaInfo: function metaInfo() {
    return {
      title: 'Страница не найдена',
      meta: [{
        name: 'prerender-status-code',
        content: '404'
      }]
    };
  }
});

/***/ }),

/***/ "3/Wh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__("ragk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4310054_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__("Xtxk");
function injectStyle (ssrContext) {
  __webpack_require__("OZBu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4310054_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3loQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("BM6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4baefe0b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("4zel");
function injectStyle (ssrContext) {
  __webpack_require__("Hc4z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4baefe0b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3yO+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4/Z9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4/dr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header container"},[_c('div',{staticClass:"col-xs-12"},[_c('router-link',{attrs:{"to":"/"}},[_c('h2',{staticClass:"logo"},[_vm._v("Вкусомер")])]),_vm._v(" "),_c('Switcher')],1),_vm._v(" "),(_vm.person.id)?_c('div',{staticClass:"person col-xs-6"},[_c('router-link',{attrs:{"to":"/upload/"}},[_c('img',{staticClass:"person--upload",attrs:{"src":"/static/icon-upload.svg"}})]),_vm._v(" "),_c('router-link',{staticClass:"person--avatar-wrap",attrs:{"to":_vm.profileLink()}},[(_vm.person.profile_photo)?_c('img',{staticClass:"person--photo",attrs:{"src":_vm.person.profile_photo},on:{"click":function($event){_vm.updateUser(_vm.person.id)}}}):(_vm.person.first_name)?_c('div',{staticClass:"person--avatar",style:(("background: " + (_vm.calcColor(_vm.person.compare_etalon)))),on:{"click":function($event){_vm.updateUser(_vm.person.id)}}},[_vm._v(_vm._s(_vm.person.first_name[0])+_vm._s(_vm.person.last_name[0]))]):_vm._e(),_vm._v(" "),(_vm.personIsAdmin && _vm.fancyCounter > 0)?_c('router-link',{staticClass:"person--settings",attrs:{"to":"/moderate/web/"}},[_c('span',[_vm._v(_vm._s(_vm.fancyCounter))])]):_vm._e()],1),_vm._v(" "),_vm._m(0)],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/accounts/logout/?next=/"}},[_c('img',{staticClass:"person--exit",attrs:{"src":"/static/exit.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4aIT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4lm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'serverPage',
  metaInfo: function metaInfo() {
    return {
      title: 'Ошибка сервера',
      meta: [{
        name: 'prerender-status-code',
        content: '404'
      }]
    };
  }
});

/***/ }),

/***/ "4zel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:("footer footer-" + (_vm.theme ? _vm.theme : ''))},[_c('div',{staticClass:"footer-copy"},[_c('div',{staticClass:"footer-col footer-logo"},[_c('a',{attrs:{"href":"https://www.artlebedev.ru/"}},[_c('img',{attrs:{"src":("/static/als-logo" + (_vm.theme ? '' : '-white') + ".svg")}})])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-col"},[_c('p',[_vm._v("Задизайнено в "),_c('a',{staticClass:"white",attrs:{"href":"https://www.artlebedev.ru/"}},[_vm._v("Студии Артемия Лебедева")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"white",attrs:{"href":"https://www.artlebedev.ru/vkusomer/"}},[_vm._v("Информация о сайте")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5qpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__ = __webpack_require__("WcWR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e4447f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__ = __webpack_require__("bYBs");
function injectStyle (ssrContext) {
  __webpack_require__("9YrH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09e4447f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6MK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Heady_vue__ = __webpack_require__("2RGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781c0659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Heady_vue__ = __webpack_require__("4/dr");
function injectStyle (ssrContext) {
  __webpack_require__("92o6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Heady_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_781c0659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Heady_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Rl4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("gsqX");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "8ZoY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page container"},[_c('div',{staticClass:"col-md-8"},[_c('h3',[_vm._v("404 ошибка")]),_vm._v(" "),_c('p',[_vm._v("Неправильно набран адрес, или такой страницы больше не существует.")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Вернуться на главную.")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "92o6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Xfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.person)?_c('div',{staticClass:"user--info"},[(_vm.person.profile_photo)?_c('img',{staticClass:"user--info-photo",attrs:{"src":_vm.person.profile_photo}}):_c('div',{staticClass:"user--info-avatar",style:(("background: " + (_vm.calcColor(_vm.person.compare_etalon))))},[_vm._v(_vm._s(_vm.person.first_name ? _vm.person.first_name[0] : 'Н')+" "+_vm._s(_vm.person.last_name ? _vm.person.last_name[0] : 'Н'))]),_vm._v(" "),(!_vm.preview)?_c('p',[_vm._v(_vm._s(_vm.person.first_name || 'Неизвестный')+" "+_vm._s(_vm.person.last_name)+" шарит в "+_vm._s(_vm.calcTagLabel())+" на "+_vm._s(_vm.calcCompare(_vm.person))+"%")]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9YrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A6JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationMenu_vue__ = __webpack_require__("OLBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f76f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationMenu_vue__ = __webpack_require__("ludc");
function injectStyle (ssrContext) {
  __webpack_require__("tGY/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f76f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationMenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BB+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findObj;
function findObj(array, obj, key) {
  for (var i = 0, len = array.length; i < len; i += 1) {
    if (array[i][key] === obj) {
      return array[i];
    }
  }
  return {};
}

/***/ }),

/***/ "BM6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer',
  props: ['theme']
});

/***/ }),

/***/ "C2dT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DPuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.person.id)?_c('div',{staticClass:"rate--wrap"},[_c('RateButton'),_vm._v(" "),(_vm.refs.results && _vm.refs.results[_vm.slide])?_c('div',{class:("rate--image rate--image-" + (_vm.voteBusy || _vm.imageLoaded ? 'busy' : ''))},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption,"not-next-tick":_vm.notNextTick}},[_c('swiper-slide',[_c('img',{attrs:{"src":_vm.imageLoaded ? null : _vm.refs.results[_vm.slide].image}})])],1),_vm._v(" "),(_vm.voteBusy)?_c('div',{staticClass:"hidden",attrs:{"data":_vm.waitNewImage()}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('RateButton',{attrs:{"direction":true}}),_vm._v(" "),_c('RateIndicator'),_vm._v(" "),_c('div',{class:['rate--hint', {'rate--hint-active': _vm.hint}]},[_c('p',[_vm._v("Голосовать можно стрелками на клавиатуре ↔ ")])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dp4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Indicator_vue__ = __webpack_require__("wOq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e359e9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Indicator_vue__ = __webpack_require__("euAK");
function injectStyle (ssrContext) {
  __webpack_require__("ewcZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Indicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e359e9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Indicator_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CHANGE_NAVIGATION_THEME */
/* unused harmony export RECEIVE_COMPANIES */
/* unused harmony export FETCH_COMPANY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return RECEIVE_PERSONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_PERSONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_CURRENT_PERSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_PERSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUSY_PERSON; });
/* unused harmony export RECEIVE_NAVIGATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RECEIVE_GLOBAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return RECEIVE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return VOTE_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return VOTE_BUSY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RECEIVE_REFS; });
/* unused harmony export RECEIVE_REF */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return UPDATE_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAR_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TEMP_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return IMAGE_UPLOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INCREASE_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return VOTE_SLIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return UPDATE_FANCY_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RECEIVE_FANCY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETED_FANCY_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETED_FANCY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return UPDATE_FANCY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FANCY_LIST_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TAG_FANCY_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLEAR_FANCY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FANCY_LIST_BUSY; });
/* unused harmony export APPROVED_FANCY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RECEIVE_ADMIN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UPDATE_ADMIN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN_LIST_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADMIN_LIST_BUSY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_ADMIN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TAG_ADMIN_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_ADMIN_LIST_VOTE; });
var CHANGE_NAVIGATION_THEME = 'CHANGE_NAVIGATION_THEME';
var RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
var FETCH_COMPANY = 'FETCH_COMPANY';

var RECEIVE_PERSONS = 'RECEIVE_PERSONS';
var CLEAR_PERSONS = 'CLEAR_PERSONS';
var FETCH_CURRENT_PERSON = 'FETCH_CURRENT_PERSON';
var FETCH_PERSON = 'FETCH_PERSON';
var SET_CATEGORY = 'SET_CATEGORY';
var BUSY_PERSON = 'BUSY_PERSON';

var RECEIVE_NAVIGATION = 'RECEIVE_NAVIGATION';
var RECEIVE_GLOBAL = 'RECEIVE_GLOBAL';
var RECEIVE_PAGE = 'RECEIVE_PAGE';
var CHANGE_THEME = 'CHANGE_THEME';

var VOTE_COUNTER = 'VOTE_COUNTER';
var VOTE_BUSY = 'VOTE_BUSY';

var RECEIVE_REFS = 'RECEIVE_REFS';
var RECEIVE_REF = 'RECEIVE_REF';
var UPDATE_REF = 'UPDATE_REF';
var FETCH_REF = 'FETCH_REF';
var CLEAR_REF = 'CLEAR_REF';
var TEMP_REF = 'TEMP_REF';

var IMAGE_UPLOADED = 'IMAGE_UPLOADED';

var INCREASE_COUNTER = 'INCREASE_COUNTER';
var VOTE_SLIDE = 'VOTE_SLIDE';

var UPDATE_FANCY_COUNTER = 'UPDATE_FANCY_COUNTER';
var RECEIVE_FANCY_LIST = 'RECEIVE_FANCY_LIST';
var DELETED_FANCY_DONE = 'DELETED_FANCY_DONE';
var DELETED_FANCY_LIST = 'DELETED_FANCY_LIST';
var UPDATE_FANCY_LIST = 'UPDATE_FANCY_LIST';
var FANCY_LIST_OFFSET = 'FANCY_LIST_OFFSET';
var TAG_FANCY_UPDATE = 'TAG_FANCY_UPDATE';
var CLEAR_FANCY_LIST = 'CLEAR_FANCY_LIST';
var FANCY_LIST_BUSY = 'FANCY_LIST_BUSY';
var APPROVED_FANCY = 'APPROVED_FANCY';

var CHANGE_BLUR = 'CHANGE_BLUR';

var RECEIVE_ADMIN_LIST = 'RECEIVE_ADMIN_LIST';
var UPDATE_ADMIN_LIST = 'UPDATE_ADMIN_LIST';
var ADMIN_LIST_OFFSET = 'ADMIN_LIST_OFFSET';
var ADMIN_LIST_BUSY = 'ADMIN_LIST_BUSY';
var CLEAR_ADMIN_LIST = 'CLEAR_ADMIN_LIST';
var TAG_ADMIN_UPDATE = 'TAG_ADMIN_UPDATE';
var UPDATE_ADMIN_LIST_VOTE = 'UPDATE_ADMIN_LIST_VOTE';

/***/ }),

/***/ "Duuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__ = __webpack_require__("2U12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da4c6f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__ = __webpack_require__("8ZoY");
function injectStyle (ssrContext) {
  __webpack_require__("rX4I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da4c6f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E5WG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Share',
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    person: 'person'
  }),
  methods: {
    getTitle: function getTitle() {
      var etalon = this.person.compare_etalon >= 0 ? this.person.compare_etalon : 0;
      var percent = this.person.id === 7 ? 100 : etalon;
      return (this.person.first_name || 'Неизвестный') + ' ' + this.person.last_name + ' \u0448\u0430\u0440\u0438\u0442 \u0432 \u0434\u0438\u0437\u0430\u0439\u043D\u0435 \u043D\u0430 ' + percent + '%';
    }
  }
});

/***/ }),

/***/ "EYD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objects__ = __webpack_require__("BB+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Rate_Indicator__ = __webpack_require__("Dp4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Rate_Button__ = __webpack_require__("+D/M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RateIndicator: __WEBPACK_IMPORTED_MODULE_3__components_Rate_Indicator__["a" /* default */],
    RateButton: __WEBPACK_IMPORTED_MODULE_4__components_Rate_Button__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personIsAdmin: 'personIsAdmin',
    fancyDeleted: 'fancyDeleted',
    fancyInfo: 'fancyInfo',
    fancyList: 'fancyList',
    fancyBusy: 'fancyBusy',
    tags: 'tags'
  }),

  watch: {
    $route: function $route() {
      this.loadNew();
    }
  },

  mounted: function mounted() {
    this.loadNew();
  },


  methods: {
    loadNew: function loadNew() {
      this.$store.commit('CLEAR_FANCY_LIST');
      this.loadMore();
    },
    loadMore: function loadMore() {
      if (!this.fancyBusy) {
        this.$store.dispatch('fetchFancyList', this.$route.params.category);
      }
    },
    checkCurrentTag: function checkCurrentTag(fancy, tg) {
      var hasTag = fancy.tags && fancy.tags[0];
      if (hasTag) {
        var isActiveTemp = fancy.tags[0].value === tg.value;
        var isActiveStandard = fancy.tags[0].slug === tg.tag;
        return isActiveTemp || isActiveStandard;
      }
      return false;
    },
    approveRef: function approveRef(fancy, dir, key) {
      var tagCurrent = fancy.tags && fancy.tags[0] ? fancy.tags[0] : null;
      if (tagCurrent) {
        var tag = tagCurrent.value ? tagCurrent : this.getCurrenTag(tagCurrent);
        var data = {
          estimation: dir ? 500 : 100,
          id: fancy.id,
          tags: tag.value,
          number: key
        };
        this.$store.dispatch('approveFancy', data);
      }
    },
    getCurrenTag: function getCurrenTag(tagCurrent) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_objects__["a" /* default */])(this.tags, tagCurrent.slug, 'tag');
    },
    getCurrenTagByVal: function getCurrenTagByVal(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_objects__["a" /* default */])(this.tags, Number(value), 'value');
    },
    updateTag: function updateTag(fancy, number, e) {
      var data = {
        key: number,
        tag: this.getCurrenTagByVal(e.target.value)
      };
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["A" /* TAG_FANCY_UPDATE */], data);
    },
    deleteRef: function deleteRef(data, key) {
      var params = data;
      params.number = key;
      this.$store.dispatch('deleteFancy', params);
    },
    deleteAll: function deleteAll() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["k" /* DELETED_FANCY_LIST */], this.fancyList.length);
      for (var ref = 0; ref < this.fancyList.length; ref += 1) {
        this.$store.dispatch('deleteAllFancies', this.fancyList[ref]);
      }
      this.$store.commit('CLEAR_FANCY_LIST');
    }
  }
});

/***/ }),

/***/ "EyX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerError_vue__ = __webpack_require__("4lm1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebf5300_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ServerError_vue__ = __webpack_require__("iIBB");
function injectStyle (ssrContext) {
  __webpack_require__("X7fm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebf5300_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ServerError_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G9y/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Stat')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GkkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.person)?_c('div',{staticClass:"share"},[_c('social-sharing',{attrs:{"url":("https://vkusomer.artlebedev.ru/accounts/" + (_vm.person.id) + "/"),"title":_vm.getTitle(),"description":"«Вкусомер» — это инструмент, позволяющий каждому проверить свой дизайнерский вкус.","hashtags":"like,design,test"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},[_c('network',{attrs:{"network":"facebook"}},[_c('div',{staticClass:"SocialMediaShareButton SocialMediaShareButton--facebook"},[_c('img',{attrs:{"src":"/static/social-fb.svg"}})])]),_vm._v(" "),_c('network',{attrs:{"network":"twitter"}},[_c('div',{staticClass:"SocialMediaShareButton SocialMediaShareButton--twitter"},[_c('img',{attrs:{"src":"/static/social-tw.svg"}})])]),_vm._v(" "),_c('network',{attrs:{"network":"vk"}},[_c('div',{staticClass:"SocialMediaShareButton SocialMediaShareButton--vk"},[_c('img',{attrs:{"src":"/static/social-vk.svg"}})])]),_vm._v(" "),_c('network',{attrs:{"network":"googleplus"}},[_c('div',{staticClass:"SocialMediaShareButton SocialMediaShareButton--googlePlus"},[_c('img',{attrs:{"src":"/static/social-gl.svg"}})])]),_vm._v(" "),_vm._m(0)],1)},staticRenderFns:[function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SocialMediaShareButton SocialMediaShareButton--livejournal"},[_c('a',{attrs:{"target":"_blank","href":"http://www.livejournal.com/update.bml?subject=Вкусомер&event=%3Ca%20href%3D%22https://vkusomer.artlebedev.ru/>Вкусомер</a>"}},[_c('span',[_c('img',{attrs:{"src":"/static/social-lj.svg"}})])])])}]}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HTuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");


var _mutations;





var devEnv = "production" === 'development';
var temaId = 43;
var standardCategory = 'all';

// initial state
var state = {
  personCurrent: {},
  personIsAdmin: false,
  personIsAuth: true,
  category: standardCategory,
  tema: temaId,
  dev: devEnv,
  persons: [],
  person: {},
  busy: true
};

// getters
var getters = {
  personBusy: function personBusy(stateFreezed) {
    return stateFreezed.busy;
  },
  persons: function persons(stateFreezed) {
    return stateFreezed.persons;
  },
  person: function person(stateFreezed) {
    return stateFreezed.person;
  },
  personIsAuth: function personIsAuth(stateFreezed) {
    return stateFreezed.personIsAuth;
  },
  personIsAdmin: function personIsAdmin(stateFreezed) {
    return stateFreezed.personIsAdmin;
  },
  personCurrent: function personCurrent(stateFreezed) {
    return stateFreezed.personCurrent;
  },
  category: function category(stateFreezed) {
    return stateFreezed.category;
  },
  tema: function tema(stateFreezed) {
    return stateFreezed.tema;
  },
  dev: function dev(stateFreezed) {
    return stateFreezed.dev;
  }
};

// actions
/* eslint-disable */
var actions = {
  fetchPersons: function fetchPersons(_ref, position) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* RECEIVE_PERSONS */], {});

    var tag = state.category === standardCategory ? '' : '&tag=' + state.category;

    var offset = position > 0 ? position - 10 : 0;
    if (offset < 0) offset = 0;

    if (position !== null) {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('users/?offset=' + offset + tag).then(function (response) {
          if (response.body) {
            commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* RECEIVE_PERSONS */], response.body);
          }
        }, 200);
      });
    }
  },
  fetchPersonsWithNewTag: function fetchPersonsWithNewTag(_ref2, position) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* RECEIVE_PERSONS */], {});
    var tag = state.category === standardCategory ? '' : '&tag=' + state.category;

    var offset = position > 0 ? position - 10 : 0;
    if (offset < 0) offset = 0;

    if (position == null) {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('users/?offset=' + offset + tag).then(function (response) {
          if (response.body) {
            dispatch('fetchPerson', response.body.results[1].id);
            setTimeout(function () {
              commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* RECEIVE_PERSONS */], response.body);
            }, 1000);
          }
        }, 200);
      });
    }
  },
  fetchCurrentPerson: function fetchCurrentPerson(_ref3) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('v1/whoami/').then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* FETCH_CURRENT_PERSON */], response.body);
    }, function () {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* FETCH_CURRENT_PERSON */], {});
    });
  },
  fetchPerson: function fetchPerson(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state;

    if (state.person && id !== state.person.id) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('users/' + id + '/').then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* FETCH_PERSON */], response.body);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* BUSY_PERSON */], false);
      }, function () {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/404/');
      });
    }
  },
  updateFacebookOpenGraph: function updateFacebookOpenGraph(_ref5, id) {
    var commit = _ref5.commit;

    var fbxhr = new XMLHttpRequest();
    fbxhr.open('POST', 'https://graph.facebook.com/?id=https://vkusomer.artlebedev.ru/accounts/' + id + '/&scrape=true', true);
    fbxhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    fbxhr.send();
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* RECEIVE_PERSONS */], function (stateFreezed, personsFetched) {
  var st = stateFreezed;
  st.persons = personsFetched;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* FETCH_CURRENT_PERSON */], function (stateFreezed, person) {
  var st = stateFreezed;
  st.personCurrent = person;
  st.personIsAuth = person.id > 0;
  st.personIsAdmin = person && person.id === st.tema;
  if (st.personIsAdmin) {
    this.dispatch('fetchFancyCounter');
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* CLEAR_PERSONS */], function (stateFreezed) {
  var st = stateFreezed;
  st.busy = true;
  st.persons = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* FETCH_PERSON */], function (stateFreezed, person) {
  var st = stateFreezed;
  st.person = person;
  var position = person.position;

  if (st.category !== standardCategory) {
    position = st.person.per_tag_stats ? st.person.per_tag_stats[st.category] : 0;
  }

  if (stateFreezed.persons.length <= 0) {
    if (person.compare_etalon > 0) {
      this.dispatch('fetchPersons', position);
    } else {
      this.dispatch('fetchPersons', 1);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* BUSY_PERSON */], function (stateFreezed, busy) {
  var st = stateFreezed;
  st.busy = busy;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["y" /* SET_CATEGORY */], function (stateFreezed, category) {
  var st = stateFreezed;
  st.category = category;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Hc4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_persons__ = __webpack_require__("HTuS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_global__ = __webpack_require__("17x+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_fancy__ = __webpack_require__("RWib");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_admin__ = __webpack_require__("/uTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_page__ = __webpack_require__("i41M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_refs__ = __webpack_require__("cwqj");










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    persons: __WEBPACK_IMPORTED_MODULE_2__store_modules_persons__["a" /* default */],
    globals: __WEBPACK_IMPORTED_MODULE_3__store_modules_global__["a" /* default */],
    fancy: __WEBPACK_IMPORTED_MODULE_4__store_modules_fancy__["a" /* default */],
    admin: __WEBPACK_IMPORTED_MODULE_5__store_modules_admin__["a" /* default */],
    page: __WEBPACK_IMPORTED_MODULE_6__store_modules_page__["a" /* default */],
    refs: __WEBPACK_IMPORTED_MODULE_7__store_modules_refs__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ "JG9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__ = __webpack_require__("mvQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e854094_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__ = __webpack_require__("9Xfj");
function injectStyle (ssrContext) {
  __webpack_require__("vjwd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e854094_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JOXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_colorLibrary__ = __webpack_require__("QIYI");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserList',
  props: ['direction'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['persons', 'person', 'tema', 'dev', 'category'])),
  data: function data() {
    return {
      listSorted: [],
      listReverse: [],
      limit: 8
    };
  },

  watch: {
    persons: function persons() {
      this.listSorted = this.list();
    }
  },
  mounted: function mounted() {
    this.listSorted = this.list();
    if (this.dev) {
      this.limit = 4;
    }
  },

  methods: {
    detectLeftNeighbour: function detectLeftNeighbour() {
      var leftNeigbour = this.listSorted[0];

      if (this.person.left_neighbor && this.person.left_neighbor.compare_etalon > 0) {
        leftNeigbour = this.person.left_neighbor;
      }

      return leftNeigbour;
    },
    detectLeftNeighbourCompare: function detectLeftNeighbourCompare() {
      var compare = this.listSorted[0] ? this.listSorted[0].compare_etalon : 0;
      if (this.person.compare_tags && this.category !== '') {
        for (var tag = 0; tag < this.person.compare_tags.length; tag += 1) {
          var tagCurr = this.person.compare_tags[tag];
          if (tagCurr.tag === this.category) {
            compare = tagCurr.value - 5;
          }
        }
      }

      return compare;
    },
    detectRightNeighbour: function detectRightNeighbour() {
      var rightNeigbour = {
        compare_etalon: 100,
        id: this.tema
      };
      if (this.category === '' && this.person.right_neighbor && this.person.right_neighbor.compare_etalon > 0) {
        rightNeigbour = this.person.right_neighbor;
      }
      return rightNeigbour;
    },
    updateUser: function updateUser(userId) {
      var _this = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["h" /* CLEAR_PERSONS */]);
      setTimeout(function () {
        _this.$store.dispatch('fetchPerson', userId);
      }, 200);
    },
    list: function list() {
      var list = this.persons.results ? this.persons.results.slice(0) : [];
      if (list && list.length > 0) {
        this.listReverse = list.reverse();
        var listFiltered = [];

        for (var p = 0; p < this.listReverse.length; p += 1) {
          if (this.listReverse[p].id && this.checkUsersDirection(this.listReverse[p], p)) {
            listFiltered.push(this.listReverse[p]);
          }
        }
        return listFiltered;
      }
      return [];
    },
    calcColor: function calcColor(coeff) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_colorLibrary__["a" /* default */])(coeff).top;
    },
    calcOpacity: function calcOpacity(key) {
      if (this.listSorted && this.listSorted.length > 4) {
        if (this.direction) {
          return this.getOpacity(this.listSorted.length - key);
        } else if (!this.direction && key < 3) {
          return this.getOpacity(key + 1);
        }
      }
      return 1;
    },
    calcPosition: function calcPosition(key) {
      if (this.listSorted && this.listSorted.length > 4) {
        var position = key + 1;
        var positionCoeff = 5;
        if (this.direction) {
          return -(position * positionCoeff) / (this.listSorted.length - position + 1);
        } else if (!this.direction) {
          return (this.listSorted.length - key) * positionCoeff / position;
        }
      }
      return 0;
    },
    calcScale: function calcScale(key) {
      if (this.listSorted && this.listSorted.length > 4) {
        if (this.direction) {
          if (key === this.listSorted.length - 1) return 0.85;
          if (key === this.listSorted.length - 2) return 0.9;
        } else if (!this.direction) {
          if (key === 0) return 0.8;
          if (key === 1) return 0.9;
        }
      }
      return 1;
    },
    calcPercentColor: function calcPercentColor(coeff) {
      return 'rgb(' + (252 - coeff) + ',' + (100 + Math.floor(coeff * 1.1)) + ',' + (20 + Math.floor(coeff / 10)) + ')';
    },
    calcZindex: function calcZindex(key) {
      return this.direction ? this.listSorted.length + 1 - key : key;
    },
    getPosition: function getPosition(value) {
      switch (value) {
        case 1:
          return 50;
        case 2:
          return 25;
        case 3:
          return 0;
        default:
          return 0;
      }
    },
    getOpacity: function getOpacity(value) {
      switch (value) {
        case 1:
          return 0.3;
        case 2:
          return 0.6;
        case 3:
          return 0.8;
        default:
          return 1;
      }
    },
    calcLink: function calcLink(category) {
      var cat = category === '' ? '' : '/' + category;
      return cat;
    },
    checkUsersDirection: function checkUsersDirection(men, key) {
      var _this2 = this;

      var isTema = this.tema === men.id;
      var currentPersonPosition = this.listReverse.findIndex(function (x) {
        return x.id === _this2.person.id;
      }) || 10;
      var comparePositions = currentPersonPosition > key;
      var isLeft = comparePositions && !this.direction && !isTema;
      var isRight = !comparePositions && this.direction || isTema;

      return this.person.id !== men.id && (isLeft || isRight);
    }
  }
});

/***/ }),

/***/ "L9oa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"container admin-container",attrs:{"infinite-scroll-disabled":_vm.adminBusy,"infinite-scroll-throttle-delay":300,"infinite-scroll-distance":200}},[(_vm.personIsAdmin)?[_c('div',{staticClass:"admin-container-wrap"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-12"},[_c('h3',[_vm._v("Модерация картинок с оценками")]),_vm._v(" "),_c('div',{staticClass:"switcher"},_vm._l((_vm.tags),function(cat){return _c('div',{staticClass:"switcher-link"},[_c('router-link',{class:['switcher-link-a', {'switcher-link-a-active': cat.tag === _vm.$route.params.category}],attrs:{"to":("/refs/" + (cat.tag) + "/")}},[_vm._v(_vm._s(cat.name))])],1)}))]),_vm._v(" "),(_vm.adminList && _vm.adminList.length)?_vm._l((_vm.adminList),function(ref, key){return _c('div',{class:("admin " + (ref.tags[0] && ref.tags[0].slug && ref.tags[0].slug.indexOf('web') > -1 ? 'col-md-11' : 'col-md-5'))},[_c('span',{staticClass:"admin-delete",on:{"click":function($event){_vm.deleteRef(ref, key)}}},[_c('img',{attrs:{"src":"/static/icon-delete.svg"}})]),_vm._v(" "),_c('span',{staticClass:"admin-number"},[_vm._v("№ "+_vm._s(key + 1))]),_vm._v(" "),_c('div',{staticClass:"admin-image"},[_c('img',{attrs:{"src":ref.image}})]),_vm._v(" "),_c('div',{staticClass:"admin-tags-wrap"},[_c('select',{staticClass:"admin-tags",on:{"change":function($event){_vm.updateTag(ref, key, $event)}}},_vm._l((_vm.tags),function(tg){return _c('option',{domProps:{"selected":_vm.checkCurrentTag(ref, tg),"value":tg.value}},[_vm._v(_vm._s(tg.name))])}))]),_vm._v(" "),_c('div',{staticClass:"admin-rate"},[_c('div',{class:['admin-rate-down',{'admin-rate-down-active': ref.has_estimated === 100}],on:{"click":function($event){_vm.voteRef(ref, 100, key)}}},[_c('svg',{attrs:{"width":"39","height":"37","viewBox":"0 0 39 37"}},[_c('path',{attrs:{"transform":"translate(0, 16)","d":"M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"}}),_vm._v(" "),_c('path',{attrs:{"transform":"translate(11, 0)","d":"M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"}})])]),_vm._v(" "),_c('div',{class:['admin-rate-up',{'admin-rate-up-active': ref.has_estimated === 500}],on:{"click":function($event){_vm.voteRef(ref, 500, key)}}},[_c('svg',{attrs:{"width":"39","height":"37","viewBox":"0 0 39 37"}},[_c('path',{attrs:{"transform":"translate(0, 16)","d":"M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"}}),_vm._v(" "),_c('path',{attrs:{"transform":"translate(11, 0)","d":"M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"}})])])])])}):_vm._e()],2)])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("1XP8");
function injectStyle (ssrContext) {
  __webpack_require__("WpCr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_76cf7b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("pHi+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_76cf7b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_social_sharing__ = __webpack_require__("VK1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_pollyfillFileList__ = __webpack_require__("fTco");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_cookies__ = __webpack_require__("zsD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_social_sharing___default.a);

Object(__WEBPACK_IMPORTED_MODULE_8__utils_pollyfillFileList__["a" /* default */])();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  // store django's CSRF token
  var token = Object(__WEBPACK_IMPORTED_MODULE_9__utils_cookies__["a" /* default */])('csrftoken');
  request.headers.set('X-CSRFToken', token);
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = '/api';

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({ // eslint-disable-line no-new
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_10__App__["a" /* default */] }
});

/***/ }),

/***/ "Nklb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RateButton',
  props: ['direction'],
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    voteCounter: 'voteCounter',
    voteBusy: 'voteBusy',
    tempRefs: 'tempRefs',
    personCurrent: 'personCurrent',
    refs: 'refs'
  }),
  data: function data() {
    return {
      scale: 1
    };
  },
  mounted: function mounted() {
    document.body.addEventListener('mousemove', this.mouseMove);
    document.body.addEventListener('touchmove', this.mouseMove);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('mousemove', this.mouseMove);
    document.body.removeEventListener('touchmove', this.mouseMove);
  },

  methods: {
    mouseMove: function mouseMove(e) {
      var middle = window.innerWidth / 2;
      var distance = this.direction ? e.pageX - middle : middle - e.pageX;
      var scale = 1 + Math.floor(distance) / window.innerWidth;
      if (scale > 1.3) scale = 1.3;
      this.scale = scale;
    },
    vote: function vote() {
      var _this = this;

      var val = this.direction ? 500 : 100;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["H" /* VOTE_BUSY */], true);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["B" /* TEMP_REF */], {
        ref: this.refs.results[this.voteCounter],
        value: val
      });
      setTimeout(function () {
        _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["I" /* VOTE_COUNTER */], val);
        if (_this.voteCounter >= _this.refs.results.length) {
          _this.$store.dispatch('voteRefs');
          _this.$store.dispatch('updateFacebookOpenGraph', _this.personCurrent.id);
          _this.$router.push('/accounts/' + _this.personCurrent.id + '/');
        }
      }, 500);
    }
  }
});

/***/ }),

/***/ "OLBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    menu: 'navigation'
  }),
  props: ['parent']
});

/***/ }),

/***/ "OZBu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q5SI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.personCurrent.id > 0)?_c('div',[_c('Stat')],1):(!_vm.personIsAuth)?_c('div',{staticClass:"greeting container"},[_c('div',{staticClass:"col-m-12 greeting--txt"},[_c('p',[_vm._v("«Вкусомер» — это инструмент, позволяющий каждому проверить свой дизайнерский вкус. С его помощью профессиональные дизайнеры оттачивают свое мастерство, работодатели проверяют исполнителей, а любители выявляют свои сильные и слабые стороны.")]),_vm._v(" "),_c('div',{staticClass:"greeting--auth"},[_c('p',[_vm._v("Вход")]),_vm._v(" "),_c('a',{staticClass:"greeting--auth-button greeting--auth-button--vk",attrs:{"href":"/accounts/login/vk-oauth2/?redirect_uri=/&next=/"}},[_c('svg',{attrs:{"viewBox":"0 0 200 200"}},[_c('circle',{attrs:{"fill":"#0077FF","cx":"100","cy":"100","r":"100"}})]),_vm._v(" "),_c('img',{attrs:{"src":"/static/social-vk.svg"}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('Footy',{attrs:{"theme":'dark'}})],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"greeting__terms"},[_vm._v("Авторизуясь, я даю согласие"),_c('br'),_vm._v("\n          на обработку моих "),_c('a',{attrs:{"href":"/static/terms.pdf"}},[_vm._v("персональных данных")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QIYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getColor;
function getColor(value) {
  var rounded = Math.ceil(value / 10) * 10;
  var colors = {
    0: {
      top: '#FF981E',
      bottom: '#FF002E'
    },
    10: {
      top: '#FFA927',
      bottom: '#FF3D00'
    },
    20: {
      top: '#FFB627',
      bottom: '#FF5C00'
    },
    30: {
      top: '#FED02C',
      bottom: '#F77B08'
    },
    40: {
      top: '#FFDD2C',
      bottom: '#F99909'
    },
    50: {
      top: '#EDD70D',
      bottom: '#E9A906'
    },
    60: {
      top: '#CFE102',
      bottom: '#C3A400'
    },
    70: {
      top: '#CFE44E',
      bottom: '#73A703'
    },
    80: {
      top: '#99DF40',
      bottom: '#65A533'
    },
    90: {
      top: '#58DF5D',
      bottom: '#48A639'
    },
    100: {
      top: '#30E52C',
      bottom: '#19A057'
    }
  };
  return colors[rounded];
}

/***/ }),

/***/ "RWib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");


var _mutations;




// initial state
var state = {
  fancyBusy: false,
  fancyOffset: 0,
  fancyCounter: 0,
  fancyInfo: {},
  fancyList: [],
  fancyDeleted: 10000
};

// getters
var getters = {
  fancyBusy: function fancyBusy(stateFreezed) {
    return stateFreezed.fancyBusy;
  },
  fancyList: function fancyList(stateFreezed) {
    return stateFreezed.fancyList;
  },
  fancyInfo: function fancyInfo(stateFreezed) {
    return stateFreezed.fancyInfo;
  },
  fancyCounter: function fancyCounter(stateFreezed) {
    return stateFreezed.fancyCounter;
  },
  fancyDeleted: function fancyDeleted(stateFreezed) {
    return stateFreezed.fancyDeleted;
  }
};

/* eslint-disable */

// actions
var actions = {
  fetchFancyList: function fetchFancyList(_ref, tag) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* FANCY_LIST_BUSY */], true);
    var hasTag = tag && tag !== '';
    var filterTag = hasTag ? '&tag=' + tag : '';

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('refs/uploaded/?offset=' + state.fancyOffset + filterTag).then(function (response) {
      if (response.body.results) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* RECEIVE_FANCY_LIST */], response.body);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* FANCY_LIST_OFFSET */]);
        if (response.body.next) commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* FANCY_LIST_BUSY */], false);
        if (!hasTag) {
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* UPDATE_FANCY_COUNTER */], response.body.count);
        }
      }
    });
  },
  fetchFancyCounter: function fetchFancyCounter(_ref2) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('refs/uploaded/').then(function (response) {
      if (response.body.results) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* UPDATE_FANCY_COUNTER */], response.body.count);
      }
    });
  },
  approveFancy: function approveFancy(_ref3, params) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.put('refs/uploaded/' + params.id + '/approve_and_estimate_by_tema/', { estimation: params.estimation }, { emulateJSON: true }).then(function (response) {
      dispatch('changeTagRef', { id: response.body.id, tags: params.tags });
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* UPDATE_FANCY_LIST */], params.number);
    });
  },
  deleteFancy: function deleteFancy(_ref4, params) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        state = _ref4.state;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.delete('refs/uploaded/' + params.id + '/');
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* UPDATE_FANCY_LIST */], params.number);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* UPDATE_FANCY_COUNTER */], state.fancyCounter - 1);
  },
  deleteAllFancies: function deleteAllFancies(_ref5, params) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.delete('refs/uploaded/' + params.id + '/').then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* DELETED_FANCY_DONE */]);
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* UPDATE_FANCY_COUNTER */], state.fancyCounter - 1);
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["t" /* RECEIVE_FANCY_LIST */], function (stateFreezed, fancyFetched) {
  var st = stateFreezed;
  st.fancyInfo = fancyFetched;
  st.fancyList = st.fancyList.concat(fancyFetched.results);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* UPDATE_FANCY_LIST */], function (stateFreezed, key) {
  var st = stateFreezed;
  st.fancyList.splice(key, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* FANCY_LIST_OFFSET */], function (stateFreezed) {
  var st = stateFreezed;
  st.fancyOffset += 20;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* FANCY_LIST_BUSY */], function (stateFreezed, status) {
  var st = stateFreezed;
  st.fancyBusy = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* DELETED_FANCY_LIST */], function (stateFreezed, deleted) {
  var st = stateFreezed;
  st.fancyDeleted = deleted;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* DELETED_FANCY_DONE */], function (stateFreezed) {
  var st = stateFreezed;
  st.fancyDeleted -= 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* CLEAR_FANCY_LIST */], function (stateFreezed) {
  var st = stateFreezed;
  st.fancyBusy = false;
  st.fancyOffset = 0;
  st.fancyList = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["E" /* UPDATE_FANCY_COUNTER */], function (stateFreezed, number) {
  var st = stateFreezed;
  st.fancyCounter = number;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["A" /* TAG_FANCY_UPDATE */], function (stateFreezed, params) {
  var st = stateFreezed;
  var updatedList = st.fancyList;
  var updatedRef = st.fancyList[params.key];
  updatedRef.tags = [params.tag];
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(updatedList, params.key, updatedRef);
  st.fancyList = updatedList;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "SLlg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SMuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistic_vue__ = __webpack_require__("VAK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3836e70b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Statistic_vue__ = __webpack_require__("G9y/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3836e70b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Statistic_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U3Hw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-button",on:{"click":_vm.vote}},[_c('div',{class:("rate-button--back rate-button-" + (_vm.direction ? 'up' : 'down')),staticStyle:{"transform":"scale(1)"}},[_c('div',{class:("rate-button--thumbs rate-button--thumbs-" + (_vm.voteBusy ? 'animated' : ''))},[_c('div',{staticClass:"rate-button--thumbs-dir"},[_c('svg',{style:(("transform: scale(" + _vm.scale + ")")),attrs:{"width":"39","height":"37","viewBox":"0 0 39 37"}},[_c('path',{attrs:{"transform":"translate(0, 16)","d":"M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"}}),_vm._v(" "),_c('path',{attrs:{"transform":"translate(11, 0)","d":"M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UtwC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V5Tq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Share_vue__ = __webpack_require__("E5WG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e4572e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Share_vue__ = __webpack_require__("GkkD");
function injectStyle (ssrContext) {
  __webpack_require__("UtwC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e4572e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Share_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VAK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Stat__ = __webpack_require__("rAxH");
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'statistic',
  components: {
    Stat: __WEBPACK_IMPORTED_MODULE_1__layouts_Stat__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    person: 'person'
  }),
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },
  data: function data() {
    return {
      title: ''
    };
  },

  methods: {
    updateTitle: function updateTitle() {
      this.title = this.person.first_name ? this.person.first_name + ' ' + this.person.last_name : 'Вкусомер';
    }
  },
  watch: {
    person: function person() {
      this.updateTitle();
    }
  },
  beforeDestory: function beforeDestory() {
    this.title = 'Вкусомер';
  }
});

/***/ }),

/***/ "Vi+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objects__ = __webpack_require__("BB+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Rate_Indicator__ = __webpack_require__("Dp4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Rate_Button__ = __webpack_require__("+D/M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RateIndicator: __WEBPACK_IMPORTED_MODULE_2__components_Rate_Indicator__["a" /* default */],
    RateButton: __WEBPACK_IMPORTED_MODULE_3__components_Rate_Button__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personIsAdmin: 'personIsAdmin',
    adminDeleted: 'adminDeleted',
    adminInfo: 'adminInfo',
    adminList: 'adminList',
    adminBusy: 'adminBusy',
    tags: 'tags'
  }),

  watch: {
    $route: function $route() {
      this.loadNew();
    }
  },

  mounted: function mounted() {
    this.loadNew();
  },


  methods: {
    loadNew: function loadNew() {
      this.$store.commit('CLEAR_ADMIN_LIST');
      this.loadMore();
    },
    loadMore: function loadMore() {
      if (!this.adminBusy) {
        this.$store.dispatch('fetchAdminList', this.$route.params.category);
      }
    },
    checkCurrentTag: function checkCurrentTag(admin, tg) {
      var hasTag = admin.tags && admin.tags[0];
      if (hasTag) {
        var isActiveTemp = admin.tags[0] === String(tg.value);
        var isActiveStandard = admin.tags[0].slug === tg.tag;
        return isActiveTemp || isActiveStandard;
      }
      return false;
    },
    getCurrenTag: function getCurrenTag(tag) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_objects__["a" /* default */])(this.tags, tag.slug, 'tag');
    },
    voteRef: function voteRef(img, val, number) {
      var params = {
        ref: img,
        value: val,
        key: number
      };
      this.$store.dispatch('voteAdminImg', params);
    },
    updateTag: function updateTag(ref, key, e) {
      if (e.target.value) {
        var data = {
          id: ref.id,
          number: key,
          tags: e.target.value
        };
        this.$store.dispatch('TagAdminImg', data);
      }
    },
    deleteRef: function deleteRef(data, key) {
      var params = data;
      params.number = key;
      this.$store.dispatch('deleteAdminImg', params);
    }
  }
});

/***/ }),

/***/ "Vru/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibility)?_c('nav',{class:("navigation navigation-" + _vm.theme)},[_c('NavigationMenu',{attrs:{"parent":"6"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WQkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"container fancy-container",attrs:{"infinite-scroll-disabled":_vm.fancyBusy,"infinite-scroll-throttle-delay":300,"infinite-scroll-distance":200}},[(_vm.personIsAdmin)?[_c('div',{staticClass:"fancy-container-wrap"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-12"},[_c('h3',[_vm._v("Модерация новых загруженных картинок")]),_vm._v(" "),_c('div',{staticClass:"switcher"},_vm._l((_vm.tags),function(cat){return _c('div',{staticClass:"switcher-link"},[_c('router-link',{class:['switcher-link-a', {'switcher-link-a-active': cat.tag === _vm.$route.params.category}],attrs:{"to":("/moderate/" + (cat.tag) + "/")}},[_vm._v(_vm._s(cat.name))])],1)}))]),_vm._v(" "),_vm._l((_vm.fancyList),function(fancy, key){return (_vm.fancyList && _vm.fancyList.length)?_c('div',{class:("fancy " + (fancy.tags[0] && fancy.tags[0].slug && fancy.tags[0].slug.indexOf('web') > -1 ? 'col-md-11' : 'col-md-5'))},[_c('span',{staticClass:"fancy-delete",on:{"click":function($event){_vm.deleteRef(fancy, key)}}},[_c('img',{attrs:{"src":"/static/icon-delete.svg"}})]),_vm._v(" "),_c('span',{staticClass:"fancy-number"},[_vm._v("№ "+_vm._s(key + 1))]),_vm._v(" "),_c('div',{staticClass:"fancy-image"},[_c('img',{attrs:{"src":fancy.image}})]),_vm._v(" "),_c('div',{staticClass:"fancy-tags-wrap"},[_c('select',{staticClass:"fancy-tags",on:{"change":function($event){_vm.updateTag(fancy, key, $event)}}},_vm._l((_vm.tags),function(tg){return _c('option',{domProps:{"selected":_vm.checkCurrentTag(fancy, tg),"value":tg.value}},[_vm._v(_vm._s(tg.name))])}))]),_vm._v(" "),_c('div',{staticClass:"fancy-rate"},[_c('div',{staticClass:"fancy-rate-down",on:{"click":function($event){_vm.approveRef(fancy, false, key)}}},[_c('svg',{attrs:{"width":"39","height":"37","viewBox":"0 0 39 37"}},[_c('path',{attrs:{"transform":"translate(0, 16)","d":"M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"}}),_vm._v(" "),_c('path',{attrs:{"transform":"translate(11, 0)","d":"M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"}})])]),_vm._v(" "),_c('div',{staticClass:"fancy-rate-up",on:{"click":function($event){_vm.approveRef(fancy, true, key)}}},[_c('svg',{attrs:{"width":"39","height":"37","viewBox":"0 0 39 37"}},[_c('path',{attrs:{"transform":"translate(0, 16)","d":"M 0 1C 0 0.447715 0.447715 0 1 0L 7.25779 0C 7.81008 0 8.25779 0.447715 8.25779 1L 8.25779 18.7346C 8.25779 19.2869 7.81008 19.7346 7.25779 19.7346L 1 19.7346C 0.447715 19.7346 0 19.2869 0 18.7346L 0 1Z"}}),_vm._v(" "),_c('path',{attrs:{"transform":"translate(11, 0)","d":"M 6.00567 7.81939L 0 16.3835L 0 35.5596C 0.187677 35.4975 0.675638 35.4107 1.12606 35.5596C 1.57649 35.7085 2.31468 35.994 2.62748 36.1181L 21.5829 36.1181C 23.3846 36.1181 24.7108 34.6287 25.1487 33.884C 26.2748 28.6711 28.4519 17.7612 28.1516 15.825C 27.8513 13.8887 26.0246 13.4047 25.1487 13.4047L 13.5128 13.4047C 14.2635 11.3567 14.8265 7.44704 13.5128 3.72352C 12.199 0 10.1346 0 8.63315 0C 7.43201 0 6.38102 1.36529 6.00567 2.04793L 6.00567 7.81939Z"}})])])])]):_vm._e()}),_vm._v(" "),(_vm.fancyList && _vm.fancyList.length)?_c('div',{staticClass:"col-md-11 fancy-delete-all"},[_c('button',{on:{"click":function($event){_vm.deleteAll()}}},[_vm._v("Удалить все картинки без оценок")])]):_vm._e()],2)]),_vm._v(" "),((!_vm.fancyList || _vm.fancyList.length <= 0) && !_vm.fancyBusy)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 fancy-empty"},[_c('p',[_vm._v("Новых картинок без оценок нет. Вернуться на "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("главную")])],1)])]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WcWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objects__ = __webpack_require__("BB+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_colorLibrary__ = __webpack_require__("QIYI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'graph',
  props: ['preview'],
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    dev: 'dev',
    tags: 'tags',
    person: 'person',
    personBusy: 'personBusy',
    personCurrent: 'personCurrent'
  }),
  data: function data() {
    return {
      area: null,
      svgProcent: 400,
      graphHeight: 200,
      standard: 0,
      gradient: {
        up: { r: 252, g: 120, b: 0 },
        down: { r: 255, g: 85, b: 0 }
      },
      rects: [0, 0, 0, 0]
    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.calcRects);
    window.addEventListener('mousemove', this.mouseMove);
  },

  watch: {
    person: function person() {
      var _this = this;

      if (this.person.id) {
        setTimeout(function () {
          _this.calcRects();
        }, 500);
      }
    }
  },
  beforeDestro: function beforeDestro() {
    window.removeEventListener('resize', this.calcRects);
    window.removeEventListener('mousemove', this.mouseMove);
  },

  methods: {
    getTopColor: function getTopColor(coeff) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_colorLibrary__["a" /* default */])(coeff).top;
    },
    getBottomColor: function getBottomColor(coeff) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_colorLibrary__["a" /* default */])(coeff).bottom;
    },
    getScale: function getScale(coeff) {
      return 1 + coeff / 140;
    },
    getHeight: function getHeight() {
      return this.svgProcent - this.graphHeight;
    },
    getHeightGraph: function getHeightGraph(category) {
      var height = window.innerHeight;
      if (height < 800) {
        height = 800;
      }
      var graphMaxWrap = height * 80 / 100;
      var graphMax = graphMaxWrap / 2;
      var scale = this.getScale(this.getCurrentCategoryValue(category));
      return graphMax * scale - 80;
    },
    getCategoryBySlug: function getCategoryBySlug(category) {
      var tag = Object(__WEBPACK_IMPORTED_MODULE_2__utils_objects__["a" /* default */])(this.tags, category.tag, 'tag');
      return tag.name;
    },
    getCurrentCategoryValue: function getCurrentCategoryValue(category) {
      var value = null;
      for (var cat = 0; cat < this.person.compare_tags.length; cat += 1) {
        var catCurrent = this.person.compare_tags[cat];
        if (category.tag === catCurrent.tag) {
          value = catCurrent.value;
        }
      }
      return value || this.standard;
    },
    calcRects: function calcRects() {
      for (var rect = 0; rect < this.rects.length; rect += 1) {
        var rectRef = this.$refs['rect' + rect];
        if (rectRef && rectRef[0]) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.rects, rect, rectRef[0].getBoundingClientRect().height || 1);
        }
      }
    },
    isUserPage: function isUserPage() {
      return this.$route.params.user;
    },
    mouseMove: function mouseMove(e) {
      this.area = Math.floor(e.pageX / (window.innerWidth / 4));
    }
  }
});

/***/ }),

/***/ "WpCr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X7fm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xtxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.personCurrent)?_c('div',{staticClass:"acc-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"acc-dropzone col-md-12"},[_c('Dropzone')],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_ModerationRefs__ = __webpack_require__("ZlG/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Moderation__ = __webpack_require__("ojh9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Statistic__ = __webpack_require__("SMuY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Greeting__ = __webpack_require__("l3WM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Upload__ = __webpack_require__("3/Wh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Rate__ = __webpack_require__("oaUP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ServerError__ = __webpack_require__("EyX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ErrorPage__ = __webpack_require__("Duuk");













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Greeting',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Greeting__["a" /* default */]
  }, {
    path: '/rate/:slug',
    name: 'Rate',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Rate__["a" /* default */]
  }, {
    path: '/Uploads/:user',
    name: 'Statistic',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Statistic__["a" /* default */]
  }, {
    path: '/accounts/:user',
    name: 'Statistic',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Statistic__["a" /* default */]
  }, {
    path: '/moderate/:category',
    name: 'Moderation',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Moderation__["a" /* default */]
  }, {
    path: '/refs',
    name: 'ModerationRefs',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_ModerationRefs__["a" /* default */]
  }, {
    path: '/refs/:category',
    name: 'ModerationRefs',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_ModerationRefs__["a" /* default */]
  }, {
    path: '/upload',
    name: 'Upload',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Upload__["a" /* default */]
  }, {
    path: '/404',
    name: 'Error',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_ErrorPage__["a" /* default */]
  }, {
    path: '/500/',
    name: 'ServerError',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_ServerError__["a" /* default */]
  }, {
    path: '*',
    name: 'Error',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_ErrorPage__["a" /* default */]
  }, {
    path: '/:tag/accounts/:user',
    name: 'Statistic',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Statistic__["a" /* default */]
  }, {
    path: '/:tag',
    name: 'Greeting',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Greeting__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YvS6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z4iZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = browserDetect;
function browserDetect() {
  var ua = navigator.userAgent.toLowerCase();

  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      return 'chrome';
    }
    return 'safari';
  }
  if (ua.indexOf('msie') > -1 || ua.indexOf('trident') > -1) {
    if (ua.indexOf('msie 10.0') > -1) {
      return 'ie-10';
    }
    return 'ie';
  }
  if (ua.indexOf('firefox') > -1) {
    return 'mozilla';
  }
  return 'standard';
}

/***/ }),

/***/ "ZB+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropzone_vue__ = __webpack_require__("wG+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb6e2888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dropzone_vue__ = __webpack_require__("lM+8");
function injectStyle (ssrContext) {
  __webpack_require__("3yO+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropzone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb6e2888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Dropzone_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZlG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModerationRefs_vue__ = __webpack_require__("Vi+R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87cd6a4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModerationRefs_vue__ = __webpack_require__("L9oa");
function injectStyle (ssrContext) {
  __webpack_require__("4aIT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModerationRefs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87cd6a4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ModerationRefs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bVQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu__ = __webpack_require__("A6JM");
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navigation',
  components: {
    NavigationMenu: __WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    theme: 'navigationTheme',
    visibility: 'navigationVisibility'
  }),
  created: function created() {
    this.$store.dispatch('fetchNavigation', { lang: 2, $http: this.$http });
  }
});

/***/ }),

/***/ "bYBs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.person.compare_tags)?_c('div',{staticClass:"graph"},[(!_vm.preview)?_c('svg',{attrs:{"preserveAspectRatio":"none","x":"0px","y":"0px","viewBox":("0 0 1200 " + _vm.svgProcent),"enableBackground":("new 0 0 1200 " + _vm.svgProcent)}},[_c('linearGradient',{attrs:{"id":("SVGID_MAIN_" + (_vm.isUserPage())),"gradientTransform":"rotate(90)"}},[_c('stop',{staticStyle:{"stopColor":"rgb(252, 100, 10)"},attrs:{"offset":"0%"}}),_vm._v(" "),_c('stop',{staticStyle:{"stopColor":"rgb(237, 53, 100)"},attrs:{"offset":"100%"}})],1),_vm._v(" "),_vm._l((_vm.tags),function(category, key){return _c('g',[_c('rect',{ref:("rect" + key),refInFor:true,style:(("transform: scaleY(" + (_vm.getScale(_vm.getCurrentCategoryValue(category))) + ")")),attrs:{"x":(301 * key),"y":_vm.getHeight(),"fill":("url(#SVGID_MAIN_" + (_vm.isUserPage()) + ")"),"width":"301","height":_vm.graphHeight}})])})],2):_vm._e(),_vm._v(" "),_c('svg',{class:("graph-main graph-main-" + (!_vm.personBusy ? 'active' : '')),attrs:{"preserveAspectRatio":"none","x":"0px","y":"0px","viewBox":("0 0 1200 " + _vm.svgProcent),"enableBackground":("new 0 0 1200 " + _vm.svgProcent)}},_vm._l((_vm.tags),function(category, key){return _c('g',[_c('linearGradient',{attrs:{"id":("Like_" + (_vm.person.id) + "_" + key),"gradientTransform":"rotate(90)"}},[_c('stop',{style:(("stopColor: " + (_vm.getTopColor(_vm.getCurrentCategoryValue(category))))),attrs:{"offset":"0%"}}),_vm._v(" "),_c('stop',{style:(("stopColor:" + (_vm.getBottomColor(_vm.getCurrentCategoryValue(category))))),attrs:{"offset":"100%"}})],1),_vm._v(" "),_c('rect',{ref:("rect" + key),refInFor:true,style:(("transform: scaleY(" + (_vm.getScale(_vm.getCurrentCategoryValue(category))) + ")")),attrs:{"x":(301 * key),"y":_vm.getHeight(),"fill":("url(#Like_" + (_vm.person.id) + "_" + key + ")"),"width":"301","height":_vm.graphHeight}})],1)})),_vm._v(" "),(!_vm.preview)?_c('div',{class:("graph--stat graph--stat-" + (_vm.rects[0] > 0 && !_vm.personBusy ? 'active' : ''))},_vm._l((_vm.tags),function(category, key){return _c('router-link',{key:key,class:("graph--stat-cat graph--stat-cat-" + key),style:(("opacity: " + (!_vm.personBusy ? 1 : 0) + "; bottom: " + (_vm.getHeightGraph(category)) + "px")),attrs:{"to":("/rate/" + (category.tag) + "/")}},[_c('h2',{staticClass:"graph--compare"},[_vm._v(_vm._s(_vm.getCurrentCategoryValue(category))+"%")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getCategoryBySlug(category) || 'Тест'))]),_vm._v(" "),_c('p',{class:("graph--stat-test graph--stat-test-" + (_vm.area === key && (!_vm.personCurrent.id || _vm.person.id == _vm.personCurrent.id) ? 'active' : ''))},[_c('router-link',{attrs:{"to":("/rate/" + (category.tag) + "/")}},[_vm._v("Пройти тест")])],1)])})):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bjtq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("JOXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7c1d6f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("2EcO");
function injectStyle (ssrContext) {
  __webpack_require__("U3Hw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7c1d6f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bwGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("bVQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2e57a9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("Vru/");
function injectStyle (ssrContext) {
  __webpack_require__("+Mmg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2e57a9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cwqj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__("Du/2");



var _mutations;





// initial state
var state = {
  refs: [],
  ref: {},
  slide: 0,
  tempRefs: [],
  voteBusy: false,
  uploaded: false,
  voteCounter: 0
};

// getters
var getters = {
  voteCounter: function voteCounter(stateFreezed) {
    return stateFreezed.voteCounter;
  },
  voteBusy: function voteBusy(stateFreezed) {
    return stateFreezed.voteBusy;
  },
  slide: function slide(stateFreezed) {
    return stateFreezed.slide;
  },
  tempRefs: function tempRefs(stateFreezed) {
    return stateFreezed.tempRefs;
  },
  refs: function refs(stateFreezed) {
    return stateFreezed.refs;
  },
  ref: function ref(stateFreezed) {
    return stateFreezed.ref;
  },
  uploaded: function uploaded(stateFreezed) {
    return stateFreezed.uploaded;
  }
};

// actions
var actions = {
  fetchNewRefs: function fetchNewRefs(_ref, params) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* CLEAR_REF */]);
    if (params.person.id) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('refs/?estimator_exclude=' + params.person.id + '&random&tag=' + params.slug).then(function (response) {
        if (response.body) {
          if (response.body.count === 0 || response.body.count < 3) {
            dispatch('fetchRefs', params);
          } else {
            commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* RECEIVE_REFS */], response.body);
          }
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
    }
  },
  fetchRefs: function fetchRefs(_ref2, params) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* CLEAR_REF */]);
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('refs/?random&tag=' + params.slug).then(function (response) {
      if (response.body) {
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* RECEIVE_REFS */], response.body);
      }
    });
  },
  voteRef: function voteRef(_ref3, params) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('refs/' + params.ref.id + '/estimate/', { value: params.value }, { emulateJSON: true }).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["I" /* VOTE_COUNTER */], params.value);
    });
  },
  voteRefs: function voteRefs() {
    if (state.tempRefs && state.tempRefs.length > 2) {
      for (var r = 0; r < state.tempRefs.length; r += 1) {
        var params = state.tempRefs[r];
        if (params && params.ref && params.ref.id) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('refs/' + params.ref.id + '/estimate/', { value: params.value }, { emulateJSON: true });
        }
      }
    }
  },
  changeTagRef: function changeTagRef(_ref4, params) {
    var commit = _ref4.commit;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.put('refs/' + params.id + '/', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ tags: [params.tags] }), { emulateJSON: true });
  },
  createImage: function createImage(_ref5, formData) {
    var commit = _ref5.commit;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('/api/refs/upload/', formData).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* IMAGE_UPLOADED */]);
    });
  },
  deleteImage: function deleteImage(_ref6, ref) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.delete('refs/' + ref.id + '/');
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* RECEIVE_REFS */], function (stateFreezed, refs) {
  var st = stateFreezed;
  st.voteCounter = 0;
  st.slide = 0;
  st.refs = refs;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* FETCH_REF */], function (stateFreezed, ref) {
  var st = stateFreezed;
  st.ref = ref;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["G" /* UPDATE_REF */], function (stateFreezed, params) {
  var st = stateFreezed;
  st.refs[params.key] = params.value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* CLEAR_REF */], function (stateFreezed) {
  var st = stateFreezed;
  st.tempRefs = [];
  st.refs = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["B" /* TEMP_REF */], function (stateFreezed, ref) {
  var st = stateFreezed;
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(st.tempRefs, st.slide, ref);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["J" /* VOTE_SLIDE */], function (stateFreezed, number) {
  var st = stateFreezed;
  st.slide = number;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["I" /* VOTE_COUNTER */], function (stateFreezed, dir) {
  var st = stateFreezed;
  if (st.refs && st.refs.results) {
    st.tempRefs[st.slide].dir = dir;
    if (st.voteCounter === st.slide) {
      st.slide += 1;
      st.voteCounter += 1;
    } else {
      st.slide = st.voteCounter;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* VOTE_BUSY */], function (stateFreezed, busy) {
  var st = stateFreezed;
  st.voteBusy = busy;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* INCREASE_COUNTER */], function (stateFreezed) {
  var st = stateFreezed;
  st.voteCounter += 1;
  st.slide = st.voteCounter;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* IMAGE_UPLOADED */], function (stateFreezed) {
  var st = stateFreezed;
  st.uploaded = true;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "euAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.refs.results && _vm.refs.results.length > 1)?_c('div',{staticClass:"rate-indicator"},[_c('div',{staticClass:"rate-indicator--info"},[(_vm.category)?_c('div',{staticClass:"rate-indicator--category rate-indicator--counter"},[_vm._v("\n      "+_vm._s(_vm.category)+": "),_c('span',{staticClass:"rate-indicator-mobile"},[_vm._v(_vm._s(_vm.voteCounter + 1)+" из "+_vm._s(_vm.refs.results.length))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.refs.results),function(ref, key){return _c('div',{class:"rate-indicator--info-button",on:{"click":function($event){_vm.changeSlide(key)}}},[_c('div',{class:("rate-indicator--info-ball rate-indicator--info-ball-dir-" + (_vm.tempRefs[key] && _vm.tempRefs[key].value ? _vm.tempRefs[key].value > 300 : 'standard') + " rate-indicator--info-ball-" + (_vm.slide === key ? 'active' : '') + " rate-indicator--info-button-" + (_vm.voteCounter < key ? 'next' : ''))})])}),_vm._v(" "),_c('div',{staticClass:"rate-indicator--info-next",on:{"click":function($event){_vm.nextImage()}}},[_vm._v("Пропустить шаг")])],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ewcZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fTco":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = polyFileList;
// https://github.com/enyo/dropzone/issues/1640

/* eslint-disable */
function polyFileList() {
  if (!FileList.prototype.map) {
    FileList.prototype.map = function (callback) {
      var T = void 0,
          A = void 0,
          k = void 0;

      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      var O = Object(this);
      var len = O.length >>> 0;

      if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
      }

      if (arguments.length > 1) {
        T = arguments[1];
      }

      A = new Array(len);

      k = 0;

      while (k < len) {

        var kValue = void 0,
            mappedValue = void 0;
        if (k in O) {
          kValue = O[k];
          mappedValue = callback.call(T, kValue, k, O);
          A[k] = mappedValue;
        }
        k++;
      }
      return A;
    };
  }
}

/***/ }),

/***/ "hAdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("users users-" + (_vm.blur ? 'blur' : '') + " users-" + (!_vm.busy ? 'active' : ''))},[_c('UsersList',{attrs:{"direction":false}}),_vm._v(" "),_c('UserInfo',{attrs:{"person":_vm.person}}),_vm._v(" "),_c('UsersList',{attrs:{"direction":true}}),_vm._v(" "),_c('Share')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hCol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i41M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");


var _mutations;




// initial state
var state = {
  page: {},
  lang: 0,
  blur: false,
  theme: 'white'
};

// getters
var getters = {
  page: function page(stateFreezed) {
    return stateFreezed.page;
  },
  theme: function theme(stateFreezed) {
    return stateFreezed.theme;
  },
  lang: function lang(stateFreezed) {
    return stateFreezed.lang;
  },
  blur: function blur(stateFreezed) {
    return stateFreezed.blur;
  }
};

// actions
var actions = {
  fetchPage: function fetchPage(_ref, params) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('/pages/' + params.slug + '/').then(function (response) {
      // get body data
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* RECEIVE_PAGE */], response.body);
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* RECEIVE_PAGE */], function (stateFreezed, pageFetched) {
  var st = stateFreezed;
  st.page = pageFetched;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* CHANGE_THEME */], function (stateFreezed, theme) {
  var st = stateFreezed;
  st.theme = theme;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* CHANGE_BLUR */], function (stateFreezed, status) {
  var st = stateFreezed;
  st.blur = status;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "iIBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page container"},[_c('div',{staticClass:"col-md-8"},[_c('h3',[_vm._v("Ошибка 500")]),_vm._v(" "),_c('p',[_vm._v("Страница временнно недоступна.")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Вернуться на главную.")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iYet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iv8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistic"},[_c('Graph'),_vm._v(" "),_c('div',{staticClass:"statistic--users"},[_c('Users')],1),_vm._v(" "),_c('Footy')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j+PO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.compare)?_c('div',{staticClass:"acc-stat"},[_c('div',{staticClass:"acc-stat-graph"},[(_vm.drawGraph)?_c('Graph',{attrs:{"preview":true}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"acc-stat-container"},_vm._l((_vm.compare.categories),function(like, key){return _c('div',{key:key,class:("acc-stat-cat acc-stat-cat-" + key)},[_c('h3',{staticClass:"acc-stat-compare"},[_vm._v(_vm._s(like.compare || 0)+"%")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getCategoryBySlug(like) || 'Тест'))])])}))],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l3WM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Greeting_vue__ = __webpack_require__("1NEM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e31ace_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Greeting_vue__ = __webpack_require__("Q5SI");
function injectStyle (ssrContext) {
  __webpack_require__("6Rl4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Greeting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e31ace_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Greeting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lM+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropzone-wrap"},[(!_vm.uploaded)?_c('div',{staticClass:"dropzone-uploading"},[_c('h3',{staticClass:"dropzone-categories"},[_vm._v("\n      Пополнить коллекцию картинок "),_c('nobr',[_vm._v("для\n      "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tag),expression:"tag"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tag=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.tags),function(tg){return _c('option',{domProps:{"value":tg.value}},[_vm._v(_vm._s(tg.name_plural))])}))])],1),_vm._v(" "),(_vm.init)?_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions}}):_vm._e(),_vm._v(" "),(_vm.refs && _vm.refs.length > 0)?_c('div',{staticClass:"dropzone-send"},[_c('div',{staticClass:"dropzone-upload"},[_c('button',{on:{"click":_vm.uploadRefs}},[_vm._v("Загрузить")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.uploaded)?_c('div',{staticClass:"dropzone-uploaded"},[_c('p',[_vm._v("Картинки будут добавлены в базу после модерации.")]),_vm._v(" "),_c('button',{on:{"click":_vm.uploadMore}},[_vm._v("Загрузить еще")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ludc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navigation-menu"},_vm._l((_vm.menu),function(li){return (li.is_published == 1 && li.is_show_in_menu == 1 && li.parent_id == _vm.parent)?_c('li',{class:{'link-home' : li.full_path === '/'}},[_c('router-link',{attrs:{"to":li.full_path}},[_vm._v(_vm._s(li.name))])],1):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Rate_Indicator__ = __webpack_require__("Dp4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Rate_Button__ = __webpack_require__("+D/M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Rate',
  components: {
    RateIndicator: __WEBPACK_IMPORTED_MODULE_2__components_Rate_Indicator__["a" /* default */],
    RateButton: __WEBPACK_IMPORTED_MODULE_3__components_Rate_Button__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    voteCounter: 'voteCounter',
    voteBusy: 'voteBusy',
    person: 'personCurrent',
    tempRefs: 'tempRefs',
    slide: 'slide',
    refs: 'refs'
  }),

  data: function data() {
    var _this = this;

    return {
      imageLoaded: false,
      storeRefs: [],
      rateScale: {
        down: 1,
        up: 1
      },
      hint: false,
      notNextTick: true,
      swiperOption: {
        direction: 'horizontal',
        grabCursor: true,
        setWrapperSize: false,
        autoHeight: false,
        pagination: '.swiper-pagination',
        paginationClickable: false,
        mousewheelControl: false,
        observeParents: false,
        onTouchEnd: function onTouchEnd(swiper) {
          if (Math.abs(swiper.touches.currentX - swiper.touches.startX) > window.innerWidth / 6) {
            var dir = swiper.touches.currentX > swiper.touches.startX;
            var val = dir ? 500 : 100;
            _this.voteFor(val);
          }
        }
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    document.body.addEventListener('keyup', this.keyListener);
    document.body.className = 'overflow-y';
    if (this.$route.params.slug) {
      setTimeout(function () {
        _this2.$store.dispatch('fetchNewRefs', { slug: _this2.$route.params.slug, person: _this2.person });
      }, 400);
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('keyup', this.keyListener);
    document.body.className = '';
  },


  watch: {
    voteCounter: function voteCounter() {
      if (!this.$cookie.get('hinted') && this.voteCounter > 3) {
        this.$cookie.set('hinted', 'true', 9999999);
        this.showHint();
      }
    }
  },

  methods: {
    updateScale: function updateScale(swiper) {
      var dir = swiper.touches.currentX > swiper.touches.startX ? 'up' : 'down';
      var delta = Math.abs(swiper.touches.currentX - swiper.touches.startX);
      var scale = 1 + delta / 1000;
      if (scale > 1.4) scale = 1.4;
      this.rateScale[dir] = scale;
    },
    keyListener: function keyListener(e) {
      if (e.keyCode === 37) {
        // left
        this.voteFor(100);
      } else if (e.keyCode === 39) {
        // right
        this.voteFor(500);
      }
    },
    waitNewImage: function waitNewImage() {
      var _this3 = this;

      var img = new Image();
      setTimeout(function () {
        _this3.imageLoaded = true;
        img.onload = function () {
          setTimeout(function () {
            _this3.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["H" /* VOTE_BUSY */], false);
            setTimeout(function () {
              _this3.imageLoaded = false;
            }, 400);
          }, 300);
        };
        if (_this3.refs.results && _this3.refs.results[_this3.slide]) {
          img.src = _this3.refs.results[_this3.slide].image;
        }
      }, 300);
    },
    voteFor: function voteFor(val) {
      var _this4 = this;

      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["H" /* VOTE_BUSY */], true);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["B" /* TEMP_REF */], {
        ref: this.refs.results[this.voteCounter],
        value: val
      });
      setTimeout(function () {
        _this4.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["I" /* VOTE_COUNTER */], val);
        if (_this4.voteCounter >= _this4.refs.results.length) {
          _this4.$store.dispatch('voteRefs');
          _this4.$store.dispatch('updateFacebookOpenGraph', _this4.person.id);
          _this4.$router.push('/accounts/' + _this4.person.id + '/');
        }
      }, 500);
    },
    showHint: function showHint() {
      var _this5 = this;

      this.hint = true;
      setTimeout(function () {
        _this5.hint = false;
      }, 6000);
    }
  }
});

/***/ }),

/***/ "m8iD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stat_vue__ = __webpack_require__("1wd3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22d6d216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Stat_vue__ = __webpack_require__("j+PO");
function injectStyle (ssrContext) {
  __webpack_require__("tQJD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22d6d216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Stat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mvQY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_colorLibrary__ = __webpack_require__("QIYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_objects__ = __webpack_require__("BB+s");

//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserInfo',

  props: ['person', 'preview'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['tags'])),

  methods: {
    calcColor: function calcColor(coeff) {
      var color = '#ccc';
      if (coeff != null) color = Object(__WEBPACK_IMPORTED_MODULE_2__utils_colorLibrary__["a" /* default */])(coeff).top;
      return color;
    },
    calcCompare: function calcCompare(person) {
      var compare = 0;
      if (person.id === 1 || person.id === 43) {
        compare = 100;
      }
      if (person.compare_etalon >= 0) {
        compare = person.compare_etalon || 0;
      }
      if (this.person.compare_tags && this.tagIsExist()) {
        var tag = Object(__WEBPACK_IMPORTED_MODULE_3__utils_objects__["a" /* default */])(this.person.compare_tags, this.$route.params.tag, 'tag');
        if (tag && tag.value) compare = tag.value;
      }
      return compare;
    },
    calcTagLabel: function calcTagLabel() {
      var label = 'дизайне';
      if (this.tags.length && this.tagIsExist()) {
        var tag = Object(__WEBPACK_IMPORTED_MODULE_3__utils_objects__["a" /* default */])(this.tags, this.$route.params.tag, 'tag');
        if (tag && tag.name_in) label = tag.name_in;
      }
      return label;
    },
    tagIsExist: function tagIsExist() {
      return this.$route.params && this.$route.params.tag && this.$route.params.tag !== 'all';
    }
  }
});

/***/ }),

/***/ "n3qc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nFn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Graph__ = __webpack_require__("5qpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_Footer__ = __webpack_require__("3loQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_Users__ = __webpack_require__("vn4O");
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'statistic',
  components: {
    Footy: __WEBPACK_IMPORTED_MODULE_2__layouts_Footer__["a" /* default */],
    Graph: __WEBPACK_IMPORTED_MODULE_1__components_Graph__["a" /* default */],
    Users: __WEBPACK_IMPORTED_MODULE_3__layouts_Users__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    person: 'personCurrent'
  }),
  mounted: function mounted() {
    var userId = this.person.id;
    if (this.$route.params.user) {
      userId = this.$route.params.user;
    }
    this.$store.dispatch('fetchPerson', userId);
  }
});

/***/ }),

/***/ "nh49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oaUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rate_vue__ = __webpack_require__("lwYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_853dfb16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Rate_vue__ = __webpack_require__("DPuq");
function injectStyle (ssrContext) {
  __webpack_require__("YvS6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_853dfb16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Rate_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ojh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Moderation_vue__ = __webpack_require__("EYD6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a3715fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Moderation_vue__ = __webpack_require__("WQkJ");
function injectStyle (ssrContext) {
  __webpack_require__("SLlg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Moderation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a3715fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Moderation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pHi+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_40790903_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("iYet");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_40790903_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rAxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stat_vue__ = __webpack_require__("nFn2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afc4044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Stat_vue__ = __webpack_require__("iv8Y");
function injectStyle (ssrContext) {
  __webpack_require__("C2dT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afc4044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Stat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rX4I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ragk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Users_Info__ = __webpack_require__("JG9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Account_Stat__ = __webpack_require__("m8iD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Account_Dropzone__ = __webpack_require__("ZB+p");
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Upload',
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_3__components_Account_Dropzone__["a" /* default */],
    AccStat: __WEBPACK_IMPORTED_MODULE_2__components_Account_Stat__["a" /* default */],
    Info: __WEBPACK_IMPORTED_MODULE_1__components_Users_Info__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personCurrent: 'personCurrent'
  }),
  data: function data() {
    return {
      title: 'Страница пользователя'
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title
    };
  },

  methods: {
    updateTitle: function updateTitle() {
      this.title = this.personCurrent.first_name ? this.personCurrent.first_name + ' ' + this.personCurrent.last_name : 'Страница пользователя';
    }
  },
  mounted: function mounted() {
    this.updateTitle();
  }
});

/***/ }),

/***/ "rdYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personIsAdmin: 'personIsAdmin',
    person: 'personCurrent',
    fancyList: 'fancyList',
    category: 'category',
    persons: 'persons',
    theme: 'theme',
    tags: 'tags'
  }),

  data: function data() {
    return {
      all: 'all'
    };
  },


  watch: {
    $route: function $route() {
      if (this.$route.fullPath === '/') {
        this.updateCategory('all');
      }
    }
  },

  mounted: function mounted() {
    var slug = 'all';
    if (this.$route.params.tag) slug = this.$route.params.tag;
    if (!this.$route.params.user) this.updateCategory(slug);
  },


  methods: {
    updateCategory: function updateCategory(slug) {
      this.$store.commit('SET_CATEGORY', slug);
      this.$store.dispatch('fetchPersonsWithNewTag', null);
    },
    isGraph: function isGraph() {
      var pages = ['Greeting', 'Statistic'];
      return pages.includes(this.$route.name);
    },
    link: function link(slug) {
      var link = '/';
      if (slug !== '') {
        link = '/' + slug + '/';
      }
      return link;
    }
  }
});

/***/ }),

/***/ "sYzO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Users_List__ = __webpack_require__("bjtq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Users_Info__ = __webpack_require__("JG9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Users_Share__ = __webpack_require__("V5Tq");
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    UsersList: __WEBPACK_IMPORTED_MODULE_1__components_Users_List__["a" /* default */],
    UserInfo: __WEBPACK_IMPORTED_MODULE_2__components_Users_Info__["a" /* default */],
    Share: __WEBPACK_IMPORTED_MODULE_3__components_Users_Share__["a" /* default */]
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    busy: 'personBusy',
    person: 'person',
    blur: 'blur'
  })
});

/***/ }),

/***/ "tGY/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tQJD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vjwd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vn4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("sYzO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cde35370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("hAdn");
function injectStyle (ssrContext) {
  __webpack_require__("4/Z9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cde35370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wG+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    tags: 'tags'
  }),
  data: function data() {
    var _this = this;

    return {
      refs: [],
      tag: 1,
      init: true,
      uploaded: false,
      dropzoneOptions: {
        acceptedFiles: '.jpg,.jpeg,.png',
        url: '/api/refs/',
        thumbnailWidth: 150,
        thumbnailHeight: 140,
        maxFilesize: 0.5,
        maxFiles: 40,
        accept: function accept(file, done) {
          _this.acceptFiles(file, done);
        },
        dictDefaultMessage: '<p><img class="dropzone-icon" src="/static/add-icon.svg"/></p><p class="dropzone-text">Перетащить одну или несколько картинок</p><p class="dropzone-comment">JPG, PNG, каждый файл не&nbsp;более 500&nbsp;КБ</p>',
        dictFileTooBig: 'Размер файла не должен превышать 500 КБ',
        dictInvalidFileType: 'Файл должен быть в формате JPG, PNG'
      }
    };
  },

  methods: {
    acceptFiles: function acceptFiles(file) {
      this.refs.push(file);
    },
    uploadRefs: function uploadRefs() {
      this.uploaded = true;
      for (var ref = 0; ref < this.refs.length; ref += 1) {
        var formData = new FormData();
        formData.append('image', this.refs[ref]);
        formData.append('tags', this.tag);
        this.$store.dispatch('createImage', formData);
      }
      this.refs = [];
    },
    uploadMore: function uploadMore() {
      var _this2 = this;

      this.uploaded = false;
      this.init = false;
      setTimeout(function () {
        _this2.init = true;
      }, 200);
    }
  }
});

/***/ }),

/***/ "wOq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objects__ = __webpack_require__("BB+s");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RateIndicator',
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personIsAdmin: 'personIsAdmin',
    personCurrent: 'personCurrent',
    voteCounter: 'voteCounter',
    tempRefs: 'tempRefs',
    slide: 'slide',
    tags: 'tags',
    refs: 'refs'
  }),
  metaInfo: function metaInfo() {
    return {
      title: this.category
    };
  },
  data: function data() {
    return {
      size: 1,
      category: ''
    };
  },
  mounted: function mounted() {
    this.category = this.getCategoryBySlug(this.$route.params.slug);
  },

  methods: {
    getCategoryBySlug: function getCategoryBySlug(slug) {
      var tag = Object(__WEBPACK_IMPORTED_MODULE_2__utils_objects__["a" /* default */])(this.tags, slug, 'tag');
      return tag.name;
    },
    calcProgress: function calcProgress() {
      var w = document.body.clientWidth;
      var buttonsW = w / 100 * 5 * 2;
      return w / this.refs.results.length * this.voteCounter - buttonsW;
    },
    changeSlide: function changeSlide(key) {
      var _this = this;

      if (key <= this.voteCounter && key !== this.slide) {
        this.$store.commit('VOTE_BUSY', true);
        setTimeout(function () {
          _this.$store.commit('VOTE_BUSY', false);
          _this.$store.commit('VOTE_SLIDE', key);
        }, 500);
      }
    },
    deleteImage: function deleteImage() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["B" /* TEMP_REF */], {
        ref: {},
        value: null
      });
      this.nextImage();
    },
    nextImage: function nextImage() {
      var _this2 = this;

      this.$store.commit('VOTE_BUSY', true);
      setTimeout(function () {
        _this2.$store.commit('VOTE_BUSY', false);
        _this2.$store.commit('INCREASE_COUNTER');
        if (_this2.voteCounter >= _this2.refs.results.length) {
          _this2.$store.dispatch('voteRefs');
          _this2.$router.push('/accounts/' + _this2.personCurrent.id + '/');
        }
      }, 500);
    }
  }
});

/***/ }),

/***/ "xBuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switcher_vue__ = __webpack_require__("rdYc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6726c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Switcher_vue__ = __webpack_require__("2HRj");
function injectStyle (ssrContext) {
  __webpack_require__("nh49")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a6726c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Switcher_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_Heady__ = __webpack_require__("6MK/");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    personIsAdmin: 'personIsAdmin',
    person: 'personCurrent',
    browser: 'browser'
  }),
  components: {
    Heady: __WEBPACK_IMPORTED_MODULE_1__layouts_Heady__["a" /* default */]
  },
  metaInfo: {
    title: 'Вкусомер'
  },
  mounted: function mounted() {
    if (!this.person || !this.person.name) {
      this.$store.dispatch('fetchCurrentPerson');
    }
  }
});

/***/ }),

/***/ "zsD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length === 2) return parts.pop().split(';').shift();
  return '';
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// build/js/app.220c86385f792d0e8913.js